import React from "react";
import { dialogClasses } from "@mui/material";

import Typography from "@mui/material/Typography";
import MzButton from "@markaaz/ui/MzButton";
import { MzDialog, MzDialogContent } from "@markaaz/ui/MzDialogControls";

import { CheckCircle } from "assets/icons";

const sx = {
  root: {
    [`.${dialogClasses.paper}`]: {
      width: "516px"
    }
  },
  content: {
    display: "flex",
    gap: 12
  }
};

export default function DownloadReportConfirm({ open, onClose }) {
  return (
    <MzDialog sx={sx.root} open={open} onClose={onClose}>
      <MzDialogContent sx={sx.content}>
        <CheckCircle />
        <Typography variant="h5">Your Report Has Been Downloaded!</Typography>
        <MzButton variant="contained" size="large" onClick={onClose}>
          Close
        </MzButton>
      </MzDialogContent>
    </MzDialog>
  );
}
